import { createUpdateSyncSlice, SyncState } from '@sonar-software/xuder';

const applicationMaintenanceActionName = 'ApplicationMaintenance';

export type ApplicationMaintenance = { locked: boolean };

const defaultApplicationMaintenanceState: SyncState<ApplicationMaintenance> = { data: { locked: false } };

export const applicationMaintenanceSyncSlice = createUpdateSyncSlice<
	typeof applicationMaintenanceActionName,
	ApplicationMaintenance,
	ApplicationMaintenance
>({
	name: applicationMaintenanceActionName,
	state: defaultApplicationMaintenanceState
});
